import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { Zap, Mail, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connecté");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur de connexion");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white">
      {/* Form */}
      <div className="flex items-center justify-center p-8 lg:p-16">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2 mb-12">
            <div className="w-9 h-9 bg-[#002FA7] flex items-center justify-center">
              <Zap className="w-5 h-5 text-white" />
            </div>
            <div className="text-lg font-semibold tracking-tight" style={{fontFamily:"'Work Sans', sans-serif"}}>
              SmartMail<span className="text-[#FF3B30]">.AI</span>
            </div>
          </div>
          <div className="overline mb-2">// Connexion</div>
          <h1 className="text-4xl font-bold tracking-tight mb-2" style={{fontFamily:"'Work Sans', sans-serif"}}>
            Reprendre le contrôle.
          </h1>
          <p className="text-gray-600 mb-10">Triage intelligent de vos emails par IA.</p>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="overline block mb-2">Email</label>
              <div className="relative">
                <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                  data-testid="login-email-input"
                  className="w-full pl-10 pr-3 h-11 border border-gray-300 focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none transition"
                  placeholder="vous@entreprise.com"
                />
              </div>
            </div>
            <div>
              <label className="overline block mb-2">Mot de passe</label>
              <div className="relative">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
                  data-testid="login-password-input"
                  className="w-full pl-10 pr-3 h-11 border border-gray-300 focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none transition"
                  placeholder="••••••••"
                />
              </div>
            </div>
            <button
              type="submit" disabled={loading} data-testid="login-submit-btn"
              className="w-full h-11 bg-[#002FA7] hover:bg-[#002277] text-white font-medium transition-colors disabled:opacity-50"
            >
              {loading ? "Connexion…" : "Se connecter →"}
            </button>
            <div className="text-xs text-gray-500 text-center pt-2">
              Accès réservé. Contactez votre administrateur pour obtenir un compte.
            </div>
          </form>
        </div>
      </div>

      {/* Hero */}
      <div className="hidden lg:block relative" style={{
        backgroundImage: "url('https://static.prod-images.emergentagent.com/jobs/154507e1-c10f-4f42-9f01-cdb196616ba4/images/867481d5b076f87d2c35b21dd04ac82a5b8daf1fb5d70ec321e94010107670fe.png')",
        backgroundSize: "cover", backgroundPosition: "center",
      }}>
        <div className="absolute inset-0 bg-gradient-to-tr from-[#002FA7]/40 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="overline mb-3 text-white/80">// Manifesto</div>
          <div className="text-3xl font-semibold leading-tight" style={{fontFamily:"'Work Sans', sans-serif"}}>
            Vos 300 emails quotidiens, condensés en 2 résumés par jour.
          </div>
        </div>
      </div>
    </div>
  );
}
